import React, { useMemo } from 'react';
import Highcharts from 'highcharts/';
import noDataToDisaplay from 'highcharts/modules/no-data-to-display';

import HighchartsReact from 'highcharts-react-official';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { getTimeZone } from '../../../../utils/datetime.utils';
// end of import

const timeZone = getTimeZone();
noDataToDisaplay(Highcharts);

/**
 *
 *
 * Actual Component
 */

const BinUtilizationChart = ({ data, selectedRange }) => {
  const { t } = useTranslation();

  const options = useMemo(() => {
    return {
      chart: {
        type: 'spline',
        height: 500,
      },
      title: {
        text: t('Report.KioskUtil.KioskUtilizationTitle'),
      },
      subtitle: {
        text:
          moment()
            .subtract(selectedRange, 'days')
            .tz(timeZone)
            .format('MMM DD, YYYY') +
          ' - ' +
          t('Automation.Today'),
      },
      lang: {
        noData: t('Report.KioskUtil.NoDataFoundText'),
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '15px',
          color: '#303030',
        },
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: t('Report.KioskUtil.Graph.SelectLineText'),
        },
      },
      yAxis: {
        title: {
          text: `${t('Report.KioskUtil.Utilization')} (%)`,
        },
        min: 0,
      },
      tooltip: {
        headerFormat: '<b>{series.name}</b><br>',
        pointFormat: `{point.x:%a, %b %e %Y}<br> <b>${t(
          'Report.KioskUtil.Utilization'
        )}</b>: {point.y:.2f}%<br> <b>${t(
          'Report.KioskUtil.TotalBins'
        )}</b>: {point.totalBins}<br> <b>${t(
          'Report.KioskUtil.AvailableBins'
        )}</b>: {point.availableBins}`,
      },

      plotOptions: {
        series: {
          connectNulls: true,
          marker: {
            symbol: 'circle',
            fillColor: '#FFFFFF',
            enabled: false,
            radius: 2.5,
            lineWidth: 0.6,
            lineColor: null,
          },
        },
      },

      colors: [
        '#6CF',
        '#39F',
        '#06C',
        '#036',
        '#FF9933',
        '#99CC00',
        '#FF6666',
        '#0099CC',
        '#CC3399',
      ],
    };
  }, [selectedRange]);

  if (!data) return null;

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={{ ...options, series: data }}
      />
    </div>
  );
};

export default BinUtilizationChart;



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/graph-view/BinUtilizationChart.jsx